<script lang="ts" setup>
	import type { SelectOptionContext, SelectOptionItem } from '@/types'

	export type SideLinkListContext = {
		[id: string]: {
			[id: string]: unknown
			label?: string
			key: string
			badgeValue?: unknown
			active?: boolean
			disabled?: boolean
			readonly?: boolean
		}
	}

	defineProps<{
		planStatus: string
		lists: SelectOptionContext
		selected?: string
	}>()
	const emits = defineEmits<{
		(event: 'select', param: SelectOptionItem): void
	}>()
</script>

<template>
	<div class="flex flex-col">
		<div class="px-5">
			<div class="hidden h-[90px] items-center justify-between gap-4 border-b border-gray-200 py-3 md:flex">
				<h4 class="font-medium text-gray-600 sm:text-base"> Plan Status </h4>
				<shared-badge
					class="!p-[4px_18px] text-sm"
					:text="planStatus"
					:active="planStatus === 'active'"
					:pending="planStatus === 'pending'"
					:failed="planStatus != 'pending' && planStatus != 'active' && planStatus != 'ongoing'"
					:ongoing="planStatus === 'ongoing'"
					fill
				/>
			</div>
		</div>
		<ul class="flex items-center overflow-x-auto md:mt-5 md:block">
			<li
				v-for="(item, k) in lists"
				:key="k"
				class="items-center gap-x-2 whitespace-nowrap px-5 py-4 text-xs font-medium transition ease-linear md:whitespace-normal"
				:class="[
					!item?.disabled ? 'flex' : 'hidden',
					!item?.readonly ? 'hover:bg-gray-100' : '',
					{
						'bg-gray-200 text-gray-600': (item.active || item.value === selected) && !item?.readonly,
						'cursor-pointer': !item?.readonly,
						'text-gray-400': !item?.active && !item?.readonly,
						'cursor-not-allowed text-gray-300': item?.readonly
					}
				]"
				:data-testid="item.key"
				:disabled="item?.readonly"
				@click="!item.readonly && emits('select', item)"
			>
				<span class="capitalize tracking-wide"> {{ item?.label || k }}</span>
				<span
					v-if="item.badgeValue"
					class="flex h-[14px] w-[30px] items-center justify-center rounded-[40px] p-2 text-[10px] text-white"
					:class="[item.active ? 'bg-primary-2 font-medium' : 'bg-gray-300 font-normal']"
				>
					{{ item.badgeValue }}
				</span>
			</li>
		</ul>
	</div>
</template>
